import { SwyftxError } from '../SwyftxError';

export class ReCaptchaError extends SwyftxError {
  isReCaptchaError = true;
}

export const isReCaptchaError = (error?: any): error is ReCaptchaError => (error as ReCaptchaError)?.isReCaptchaError;
